module.exports = __webpack_public_path__ + "img/front-bushes.600e042d.jpg";